import { Confirmation } from 'primeng/api';

export const confirmationDialogConfig: Confirmation = {
  acceptButtonStyleClass: 'p-button-outlined p-button-rounded primary-button accept-button',
  rejectButtonStyleClass: 'p-button-outlined p-button-rounded secondary-button',
};
